import styled from 'styled-components';

const InstallWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 15px;

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    margin-top: 5px;
  }
`;

const InstallButton = styled.a`
  width: 250px;

  &:not(:last-child) {
    margin-right: 50px;
  }

  @media only screen and (max-width: 767px) {
    &:not(:last-child) {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
`;

const Wrapper = styled.div`
  padding: 22px 0;
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  position: relative;
  z-index: 0;
  animation: fadeIn cubic-bezier(0.23, 1, 0.32, 1) 1;
  opacity: 0;
  animation-fill-mode: forwards;
  animation-duration: 2s;
  animation-delay: 0.2s;

  &:nth-child(2n + 1) {
    flex-direction: row-reverse;
  }

  &:not(:last-child) {
    margin-bottom: 0;
  }

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    padding: 30px 0;

    &:not(:first-child) {
      margin-top: 30px;
    }

    &:nth-child(2n + 1) {
      flex-direction: column;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;

  h1 {
    font-size: 1.3rem;

    &:first-child {
      margin-bottom: 10px;
    }

    &:nth-child(2) {
      margin-bottom: 15px;
    }
  }

  p {
    text-align: center;
    font-size: 0.9rem;
    line-height: 1.5;
  }
`;

const Image = styled.img`
  min-width: 268px;
  max-width: 300px;

  padding: 0 10px;
  margin-top: 50px;
  margin-bottom: -32px;

  @media only screen and (max-width: 767px) {
    margin-top: 20px;
    margin-bottom: -52px;
  }
`;

export {
  InstallWrapper,
  InstallButton,
  Wrapper,
  Item,
  Content,
  Image,
};
